import { Outlet, useParams } from "react-router-dom";

import { AdminLayoutShell } from "@/components/core/admin-layout-shell";
import { persistLocale } from "@/i18n/detect-locale";
import { LocaleProvider } from "@/i18n/locale-context";
import { isLocale, type LocaleCode } from "@/i18n/types";
import { NotFoundPage } from "@/pages/not-found-page";

export function AdminLocaleRoute(): JSX.Element {
  const { locale: raw } = useParams();

  if (!isLocale(raw)) {
    return (
      <LocaleProvider locale="en">
        <NotFoundPage />
      </LocaleProvider>
    );
  }

  const locale: LocaleCode = raw;

  if (typeof window !== "undefined") {
    persistLocale(locale);
  }

  return (
    <LocaleProvider locale={locale}>
      <AdminLayoutShell>
        <Outlet />
      </AdminLayoutShell>
    </LocaleProvider>
  );
}
